const part = [
    {
        path: 'preSale-warehouse-forward-entry-list',
        name: 'preSale-warehouse-forward-entry-list',
        meta: {
            icon: 'ios-flag',
            title: '预入库单',
            notCache: true,
            access: ['S', 'B', 'C', 'H'],
            items: [
            ]
        },
        component: () => import('@/view/preSale-management/preSale-warehouse-forward-entry/preSale-warehouse-forward-entry-list')
    },
    {
        path: 'preSale-warehouse-forward-entry-edit',
        name: 'preSale-warehouse-forward-entry-edit',
        meta: {
            icon: 'ios-flag',
            title: '预入库单编辑',
            notCache: true,
            hideInMenu: true,
            access: ['S', 'B', 'C'],
            items: [
            ]
        },
        component: () => import('@/view/preSale-management/preSale-warehouse-forward-entry/preSale-warehouse-forward-entry-edit')
    },
    {
        path: 'preSale-warehouse-forward-entry-detail',
        name: 'preSale-warehouse-forward-entry-detail',
        meta: {
            icon: 'ios-flag',
            title: '预入库单详情',
            notCache: true,
            hideInMenu: true,
            access: ['S', 'B', 'C', 'H'],
            items: [
            ]
        },
        component: () => import('@/view/preSale-management/preSale-warehouse-forward-entry/preSale-warehouse-forward-entry-detail')
    }
];

export default part;
